import yup from '../../../../../translations/yup/yupLocale';

const validationSchema = yup.object({
  code: yup.string().required().label('Code'),
});

export default validationSchema;
